export var primaryColors = {
  indigo: '#603eff',
  indigoLight: '#bfb5ff',
  indigoLightAlt: '#d1c6f9',
  indigoDark: '#4D32CC',
  teal: '#43e0f0',
  tealLight: '#8fefef',
  orange: '#f65b1c',
  orangeLight: '#ff7d5a',
  forest: '#4d7523',
  forestLight: '#759b4e',
  terraCotta: '#e28f44',
  terraCottaLight: '#dfae78',
  white: '#ffffff'
}; // Secondary colors should always be used to support the primary palette.

export var secondaryColors = {
  tan: '#f4e3cc',
  tanLight: '#fef9f1',
  brown: '#6b4e2f',
  brownLight: '#b27e52',
  pink: '#ffdcee',
  pinkLight: '#fcedf5',
  navy: '#0b236d'
}; // Warm Greyscale palette is for the Marketing theme.
// Should be used for text, device borders, shape graphics, and backgrounds.

export var warmGreyscaleColors = {
  100: '#0f0c09',
  // for display headlines and subheads.
  70: '#575452',
  // for paragraphs or body copy, and device or screen outlines.
  50: '#878584',
  // for inactive tabs
  25: '#c3c2c1',
  // for disabled links & shape graphics.
  10: '#e7e6e6',
  // for shape graphics.
  4: '#f7f7f7',
  // for section backgrounds.
  0: '#ffffff'
};
export var warmGreyscaleRGB = '15, 12, 9';
export var warmGreyscaleTransparentColors = {
  100: "rgba(".concat(warmGreyscaleRGB, ", 1)"),
  90: "rgba(".concat(warmGreyscaleRGB, ", 0.9)"),
  80: "rgba(".concat(warmGreyscaleRGB, ", 0.8)"),
  70: "rgba(".concat(warmGreyscaleRGB, ", 0.7)"),
  60: "rgba(".concat(warmGreyscaleRGB, ", 0.6)"),
  50: "rgba(".concat(warmGreyscaleRGB, ", 0.5)"),
  40: "rgba(".concat(warmGreyscaleRGB, ", 0.4)"),
  30: "rgba(".concat(warmGreyscaleRGB, ", 0.3)"),
  20: "rgba(".concat(warmGreyscaleRGB, ", 0.2)"),
  10: "rgba(".concat(warmGreyscaleRGB, ", 0.1)"),
  8: "rgba(".concat(warmGreyscaleRGB, ", 0.08)"),
  5: "rgba(".concat(warmGreyscaleRGB, ", 0.05)"),
  4: "rgba(".concat(warmGreyscaleRGB, ", 0.04)"),
  0: "rgba(".concat(warmGreyscaleRGB, ", 0)")
}; // Cool Greyscale palette is for the Product theme.
// Should be used for text, device borders, shape graphics, and backgrounds.

export var coolGreyscaleColors = {
  100: '#090c12',
  90: '#212429',
  80: '#3a3d41',
  70: '#525459',
  60: '#6b6d71',
  50: '#848588',
  40: '#9d9ea0',
  30: '#b5b6b7',
  20: '#cecfd0',
  10: '#e6e7e7',
  5: '#f3f3f3',
  0: '#ffffff'
};
export var coolGreyscaleRGB = '9, 12, 18';
export var coolGreyscaleTransparentColors = {
  100: "rgba(".concat(coolGreyscaleRGB, ", 1)"),
  90: "rgba(".concat(coolGreyscaleRGB, ", 0.9)"),
  80: "rgba(".concat(coolGreyscaleRGB, ", 0.8)"),
  70: "rgba(".concat(coolGreyscaleRGB, ", 0.7)"),
  60: "rgba(".concat(coolGreyscaleRGB, ", 0.6)"),
  50: "rgba(".concat(coolGreyscaleRGB, ", 0.5)"),
  40: "rgba(".concat(coolGreyscaleRGB, ", 0.4)"),
  30: "rgba(".concat(coolGreyscaleRGB, ", 0.3)"),
  20: "rgba(".concat(coolGreyscaleRGB, ", 0.2)"),
  10: "rgba(".concat(coolGreyscaleRGB, ", 0.1)"),
  8: "rgba(".concat(coolGreyscaleRGB, ", 0.08)"),
  5: "rgba(".concat(coolGreyscaleRGB, ", 0.05)"),
  4: "rgba(".concat(coolGreyscaleRGB, ", 0.04)"),
  0: "rgba(".concat(coolGreyscaleRGB, ", 0)")
};